import { z } from "zod";

export const voleoRequestCreationSchema = z.object({
  account: z.any().optional(),
  usuarioMobile: z.any().optional(),
  sucursal: z.any().optional(),
  procedencia: z.any().optional(),
  modalidad: z.any().optional(),
  tipoServicio: z.any().optional(),
  tipoCultivo: z.any().optional(),
  producto: z.any().optional(),
  dosis: z.any().optional(),
  hectareas: z.any().optional(),
  cantidadTotalCalculada: z.any().optional(),
  valorUnitario: z.any().optional(),
  valorTotal: z.any().optional(),
  telefonoContacto: z.any().optional(),
  fechaDeseada: z.any().optional(),
  observaciones: z.any().optional(),
});
